<ng-container *transloco="let convert;">
<button
  class="dealer-group__popover-btn btn btn-outline-primary bg-white text-primary"
  [popover]="content"
  placement="bottom"
  #popover="bs-popover"
  [adaptivePosition]="false"
  [outsideClick]="true"
  (onShown)="onShown()"
  (onHidden)="onHidden()"
  type="button"
  data-test-id="app-dealer-group-e-dealer-group-button"
>
  <span class="dealer-group__popover-btn-text"> {{ displayText }}</span>
  <span class="ms-3 me-2 pe-1">({{ totalSelected$ | async }})</span
  ><i aria-hidden="true" class="ms-auto allycon-glyph-chevron-down text-primary"></i>
</button>
<ng-template #content>
  <div class="dealer-group__popover">
    <div class="dealer-group__popover-content">
      <app-dealer-group-popover></app-dealer-group-popover>
    </div>
    <button
      class="btn btn-outline-primary btn-block mt-3"
      (click)="leadSellerSearch()"
      data-track-elem="button"
      data-track-name="group - save"
      data-track-trigger="save"
      data-test-id="app-dealer-group-e-save-button"
    >
    {{convert('common.btnSave')}}
    </button>
  </div>
</ng-template>
</ng-container>
